import React, { useEffect } from 'react';
import SEO from './SEO';

function CategoryPage({ title, image, description, details, seoTitle, seoDescription, seoPath }) {
    useEffect(() => {
        const root = document.documentElement;
        root.classList.remove('preload');
    }, []);

    return (
        <div className="category-page">
            <SEO
                title={seoTitle || `Rachat ${title}`}
                description={seoDescription || description.substring(0, 160).trim()}
                path={seoPath}
            />
            <header className="category-header fade-in" style={{ backgroundImage: `url(${image})` }}>
                <div className="overlay"></div>
                <div className="hero-content">
                    <h1>{title}</h1>
                </div>
            </header>
            <main className="category-content">
                <section className="category-description">
                    <div className="description-card fade-in">
                        <p>{description}</p>
                    </div>
                </section>
                <section className="category-details">
                    <h2 className="fade-in">Détails</h2>
                    <div className="details-grid">
                        {details.map((detail, index) => (
                            <div key={index} className="detail-card fade-in">
                                <span>{detail}</span>
                            </div>
                        ))}
                    </div>
                </section>
            </main>
            <footer className="category-footer fade-in">
                <a href="/contact" className="cta-button">Contactez-nous</a>
            </footer>

            <style jsx>{`
                .category-page {
                    background: #f2f5f7;
                    min-height: 100vh;
                }

                .category-header {
                    width: 100%;
                    height: 70vh;
                    background-size: cover;
                    background-position: center;
                    background-attachment: fixed;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                    color: #fff;
                }

                .overlay {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background-color: rgba(0, 0, 0, 0.5);
                    z-index: 1;
                }

                .hero-content {
                    position: relative;
                    z-index: 2;
                    text-align: center;
                    padding: 20px;
                }

                .category-header h1 {
                    font-size: 3.5rem;
                    font-weight: bold;
                    color: #fff;
                    margin: 0;
                    text-shadow: 0 4px 12px rgba(0, 0, 0, 0.8);
                    letter-spacing: -0.02em;
                }

                .category-content {
                    max-width: 1100px;
                    margin: 0 auto;
                    padding: 48px 24px 80px;
                }

                .description-card {
                    background: #fff;
                    border-radius: 18px;
                    padding: 32px;
                    margin-bottom: 48px;
                    box-shadow: 0 8px 24px rgba(0,0,0,0.12);
                    transition: transform 0.18s ease, box-shadow 0.18s ease;
                }

                .description-card:hover {
                    transform: translateY(-4px);
                    box-shadow: 0 12px 32px rgba(0,0,0,0.16);
                }

                .description-card p {
                    font-size: 1.25rem;
                    line-height: 1.75;
                    color: #44504f;
                    margin: 0;
                    text-align: center;
                }

                .category-details h2 {
                    font-size: 2.6rem;
                    line-height: 1.1;
                    margin: 0 0 32px;
                    color: #1f2b2a;
                    letter-spacing: -0.02em;
                    text-align: center;
                }

                .details-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
                    gap: 20px;
                    margin-bottom: 48px;
                }

                .detail-card {
                    background: #fff;
                    border-radius: 12px;
                    padding: 24px;
                    box-shadow: 0 4px 16px rgba(0,0,0,0.08);
                    transition: transform 0.18s ease, box-shadow 0.18s ease;
                    border-left: 4px solid #C0A26B;
                }

                .detail-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 24px rgba(0,0,0,0.12);
                }

                .detail-card span {
                    font-size: 1.05rem;
                    line-height: 1.6;
                    color: #44504f;
                    display: block;
                }

                .category-footer {
                    text-align: center;
                    margin-top: 20px;
                }

                .cta-button {
                    display: inline-block;
                    padding: 15px 32px;
                    background-color: #C0A26B;
                    color: #20453d;
                    text-decoration: none;
                    border-radius: 25px;
                    font-weight: 600;
                    font-size: 1.1rem;
                    transition: all 0.3s ease;
                    box-shadow: 0 4px 16px rgba(192, 162, 107, 0.3);
                }

                .cta-button:hover {
                    background-color: #a67c52;
                    transform: translateY(-2px);
                    box-shadow: 0 6px 20px rgba(192, 162, 107, 0.4);
                }

                .fade-in {
                    opacity: 0;
                    transform: translateY(20px);
                    animation: fadeIn 1s ease-out forwards;
                }

                .preload .fade-in {
                    opacity: 0;
                    transform: translateY(20px);
                    animation: none;
                }

                @keyframes fadeIn {
                    from {
                        opacity: 0;
                        transform: translateY(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                @media (max-width: 1200px) {
                    .details-grid {
                        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
                    }
                }

                @media (max-width: 768px) {
                    .category-header {
                        height: 50vh;
                        background-attachment: scroll;
                    }

                    .category-header h1 {
                        font-size: 2.5rem;
                    }

                    .category-content {
                        padding: 32px 20px 60px;
                    }

                    .description-card {
                        padding: 24px;
                        margin-bottom: 32px;
                    }

                    .description-card p {
                        font-size: 1.1rem;
                    }

                    .category-details h2 {
                        font-size: 2.2rem;
                        margin-bottom: 24px;
                    }

                    .details-grid {
                        grid-template-columns: 1fr;
                        gap: 16px;
                    }

                    .detail-card {
                        padding: 20px;
                    }
                }
            `}</style>
        </div>
    );
}

export default CategoryPage;
